var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolidJsDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 76.8547C224 76.8547 160 29.7603 110.491 40.6283L106.868 41.8358C99.6226 44.2509 93.5849 47.8735 89.9623 52.7037L87.5472 56.3264L69.434 87.7226L100.83 93.7603C114.113 102.213 131.019 105.836 146.717 102.213L202.264 113.081L224 76.8547Z",
    fill: "#76B3E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M224 76.8547C224 76.8547 160 29.7603 110.491 40.6283L106.868 41.8358C99.6226 44.2509 93.5849 47.8735 89.9623 52.7037L87.5472 56.3264L69.434 87.7226L100.83 93.7603C114.113 102.213 131.019 105.836 146.717 102.213L202.264 113.081L224 76.8547Z",
    fill: "url(#paint0_linear_702_321)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9623 76.8543L85.1321 78.0619C64.6038 84.0996 58.566 103.42 69.434 120.326C81.5094 136.024 106.868 144.477 127.396 138.439L202.264 113.081C202.264 113.081 138.264 65.9864 89.9623 76.8543Z",
    fill: "#518AC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.9623 76.8543L85.1321 78.0619C64.6038 84.0996 58.566 103.42 69.434 120.326C81.5094 136.024 106.868 144.477 127.396 138.439L202.264 113.081C202.264 113.081 138.264 65.9864 89.9623 76.8543Z",
    fill: "url(#paint1_linear_702_321)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.981 131.194C182.22 122.748 173.093 116.512 162.766 113.285C152.44 110.058 141.386 109.987 131.019 113.081L56.1509 137.232L32 179.496L167.245 202.439L191.396 158.968C196.226 150.515 195.019 140.854 188.981 131.194Z",
    fill: "url(#paint2_linear_702_321)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.83 173.458C158.07 165.012 148.942 158.776 138.615 155.549C128.289 152.322 117.235 152.251 106.868 155.345L32 179.496C32 179.496 96 227.798 145.509 215.722L149.132 214.515C169.66 208.477 176.906 189.156 164.83 173.458Z",
    fill: "url(#paint3_linear_702_321)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_321",
    x1: 60.3774,
    y1: 38.2132,
    x2: 210.717,
    y2: 111.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#76B3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DCF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76B3E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_702_321",
    x1: 142.853,
    y1: 73.9562,
    x2: 116.528,
    y2: 161.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76B3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4377BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3B77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_702_321",
    x1: 49.3887,
    y1: 112.115,
    x2: 201.419,
    y2: 215.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315AA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#518AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#315AA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_702_321",
    x1: 117.977,
    y1: 124.552,
    x2: 56.6339,
    y2: 349.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4377BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A336B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A336B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidJsDark);
export default __webpack_public_path__ + "static/media/SolidJS-Dark.30618afff9a63cb6c0c496e6cefacad3.svg";
export { ForwardRef as ReactComponent };